<div class="col-auto">
  <div class="row align-items-center">
    <div class="header-search">

      <button class="header-search-open header-icon d-block d-md-none" (click)="toggleSearch()"><i class="fa fa-search"></i>
      </button>

      <div class="header-search-desktop d-none d-md-flex align-items-center">
        <form [formGroup]="reactiveForm" (ngSubmit)="goToDetaglioIsin()" class="insert-isin-form">
          <mat-form-field class="full-width-field">
            <mat-label>Inserisci codice isin</mat-label>
            <input
              type="text"
              matInput
              formControlName="isin"
              [matAutocomplete]="auto"
              required>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option}} | {{searchStore.autocompleteValues[option]}}
              </mat-option>
            </mat-autocomplete>
            <button
              [disabled]="reactiveForm.invalid"
              matSuffix
              mat-icon-button
              color="primary">
              <mat-icon class="fa fa-search"></mat-icon>
            </button>
          </mat-form-field>
        </form>

        <a (click)="toggleSearch()">Ricerche salvate</a>
      </div>
    </div>

  </div>
</div>
